// Dashboard components
import MDButton from "components/MDButton";

// @mui material components
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

const StandardButton = ({
  onClick,
  disabled,
  tooltip,
  icon,
  color,
  ...props
}) => {
  return (
    <Tooltip title={tooltip}>
      <MDButton
        onClick={onClick}
        disabled={disabled}
        variant="contained"
        iconOnly
        size="small"
        type="button"
        {...props}
        color={color}
        style={
          disabled
            ? { background: "grey", color: "white", marginLeft: "5px" }
            : props?.style
        }
      >
        <Icon>{icon}</Icon>
      </MDButton>
    </Tooltip>
  );
};

export default StandardButton;
